/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  CommentTree,
  ErrorInfo,
  CommentSearchConditions,
  BinaryFile
} from '.././model'


/**
 * コメント一覧を検索して返す。

 * @summary コメント一覧検索
 */
export const postCommentsSearch = (
    productionId: number,
    commentSearchConditions: CommentSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CommentTree>> => {
    return axios.post(
      `/comments/search/${productionId}`,
      commentSearchConditions,options
    );
  }



    export type PostCommentsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postCommentsSearch>>>
    export type PostCommentsSearchMutationBody = CommentSearchConditions
    export type PostCommentsSearchMutationError = AxiosError<ErrorInfo>

    export const usePostCommentsSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommentsSearch>>, TError,{productionId: number;data: CommentSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommentsSearch>>, {productionId: number;data: CommentSearchConditions}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postCommentsSearch(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postCommentsSearch>>, TError, {productionId: number;data: CommentSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * コメント一覧をファイルに出力する。  
リクエストボディで出力対象のコメントを指定する。

 * @summary コメント出力
 */
export const postCommentsDownload = (
    productionId: number,
    commentTree: CommentTree, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/comments/download/${productionId}`,
      commentTree,options
    );
  }



    export type PostCommentsDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postCommentsDownload>>>
    export type PostCommentsDownloadMutationBody = CommentTree
    export type PostCommentsDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostCommentsDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommentsDownload>>, TError,{productionId: number;data: CommentTree}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommentsDownload>>, {productionId: number;data: CommentTree}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postCommentsDownload(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postCommentsDownload>>, TError, {productionId: number;data: CommentTree}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * コメント添付ファイルを取得する。

 * @summary コメント添付ファイル取得
 */
export const getCommentsAttachedFile = (
    fileId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/comments/attachedFile/${fileId}`,options
    );
  }


export const getGetCommentsAttachedFileQueryKey = (fileId: number,) => [`/comments/attachedFile/${fileId}`];

    
export type GetCommentsAttachedFileQueryResult = NonNullable<Awaited<ReturnType<typeof getCommentsAttachedFile>>>
export type GetCommentsAttachedFileQueryError = AxiosError<ErrorInfo>

export const useGetCommentsAttachedFile = <TData = Awaited<ReturnType<typeof getCommentsAttachedFile>>, TError = AxiosError<ErrorInfo>>(
 fileId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCommentsAttachedFile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCommentsAttachedFileQueryKey(fileId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommentsAttachedFile>>> = ({ signal }) => getCommentsAttachedFile(fileId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getCommentsAttachedFile>>, TError, TData>(queryKey, queryFn, {enabled: !!(fileId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * コメントIDに紐づくコメント添付ファイル(複数の場合あり)をzip圧縮して取得する。

 * @summary コメント添付ファイル取得(複数ファイル対応)
 */
export const getCommentsAttachedFiles = (
    internalCommentId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/comments/attachedFiles/${internalCommentId}`,options
    );
  }


export const getGetCommentsAttachedFilesQueryKey = (internalCommentId: string,) => [`/comments/attachedFiles/${internalCommentId}`];

    
export type GetCommentsAttachedFilesQueryResult = NonNullable<Awaited<ReturnType<typeof getCommentsAttachedFiles>>>
export type GetCommentsAttachedFilesQueryError = AxiosError<ErrorInfo>

export const useGetCommentsAttachedFiles = <TData = Awaited<ReturnType<typeof getCommentsAttachedFiles>>, TError = AxiosError<ErrorInfo>>(
 internalCommentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCommentsAttachedFiles>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCommentsAttachedFilesQueryKey(internalCommentId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommentsAttachedFiles>>> = ({ signal }) => getCommentsAttachedFiles(internalCommentId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getCommentsAttachedFiles>>, TError, TData>(queryKey, queryFn, {enabled: !!(internalCommentId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * コメントIDに紐づくコメント添付ファイル(複数の場合あり)をzip圧縮して取得する。

 * @summary コメント添付ファイル取得(複数ファイル対応)
 */
export const getCommentsAttachedThreadFiles = (
    internalCommentThreadId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/comments/attachedThreadFiles/${internalCommentThreadId}`,options
    );
  }


export const getGetCommentsAttachedThreadFilesQueryKey = (internalCommentThreadId: string,) => [`/comments/attachedThreadFiles/${internalCommentThreadId}`];

    
export type GetCommentsAttachedThreadFilesQueryResult = NonNullable<Awaited<ReturnType<typeof getCommentsAttachedThreadFiles>>>
export type GetCommentsAttachedThreadFilesQueryError = AxiosError<ErrorInfo>

export const useGetCommentsAttachedThreadFiles = <TData = Awaited<ReturnType<typeof getCommentsAttachedThreadFiles>>, TError = AxiosError<ErrorInfo>>(
 internalCommentThreadId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCommentsAttachedThreadFiles>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCommentsAttachedThreadFilesQueryKey(internalCommentThreadId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommentsAttachedThreadFiles>>> = ({ signal }) => getCommentsAttachedThreadFiles(internalCommentThreadId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getCommentsAttachedThreadFiles>>, TError, TData>(queryKey, queryFn, {enabled: !!(internalCommentThreadId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

